// src/finance/expenseMath.ts
// Conversion et préremplissage des récurrentes (spec dépenses annuelles 2026-08-20).
// monthlyAmountOf : le montant MENSUALISÉ d'une ligne — les montants /an sont
// stockés en annuel et lissés /12 partout où la simulation consomme un total.
// prefillForMonth : lignes réelles proposées pour un mois — reçoit des
// récurrentes DÉJÀ filtrées (company + actives) par l'appelant.
import type { ExpensePeriodicity, RecurringExpense } from '../lib/types'
import { round2 } from './engine/tax'
import type { MonthExpenseInput } from './api'

export function monthlyAmountOf(line: { amount: number; periodicity: ExpensePeriodicity }): number {
  return line.periodicity === 'yearly' ? round2(line.amount / 12) : line.amount
}

/** Mois d'échéance par défaut d'une /an non datée — le même que celui présélectionné
 *  par ExpenseListEditor quand on bascule une ligne en /an. */
const DEFAULT_DUE_MONTH = 1

export function prefillForMonth(expenses: RecurringExpense[], month: string): MonthExpenseInput[] {
  const monthNumber = Number(month.slice(5))
  return expenses
    .filter((e) => {
      if (e.periodicity === 'monthly') return true
      // Une /an non datée était « jamais préremplie » : elle pesait pourtant dans
      // l'objectif mensuel lissé (/12) sans jamais apparaître dans un mois réel,
      // creusant un écart permanent et silencieux sur le delta de dépenses.
      // Faute de date connue, elle échoit en janvier — une fois, et une seule.
      return (e.dueMonth ?? DEFAULT_DUE_MONTH) === monthNumber
    })
    .map((e) => ({ label: e.label, amount: e.amount, recurringId: e.id }))
}
